import SelectWrapper, { SelectWrapperProps } from './SelectWrapper'

export default SelectWrapper
export type { SelectWrapperProps }
